/**
 * 建容器 / editor-remote 查版本用的逻辑 origin。
 * 存在 `window.WUJI_META.origin` 且为 http(s) 时用它，否则 `location.origin`。
 */
export function getLocationOrigin() {
    const raw = window.WUJI_META?.origin;
    if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (trimmed) {
            try {
                const url = new URL(trimmed);
                if (url.protocol === 'http:' || url.protocol === 'https:') {
                    return url.origin;
                }
            }
            catch {
                // 非法 URL 回落 location.origin
            }
        }
    }
    return window.location.origin;
}
